<template>
    <div>
      <v-row>
        <v-col
          cols="12"
          md="6">
          <v-card
            flat
            class="mb-6"
            style="border: 2px dashed #e0e0e0; border-radius: 10px;">
            <v-card-text>
              <ValidationProvider 
                name="Nomor Surat" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Nomor Surat
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  
                  placeholder="Contoh. SRT/PRK/20240102/0001"
                  hide-details
  
                  v-model="form.number"
                  :success="valid"
                  :error-messages="errors"
                  required
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nomor Surat {{ errors[0] }}
                      </v-tooltip>
                    </div>
  
                    <div v-if="form.number !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
  
              <ValidationProvider 
                name="Tujuan Penerima" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Tujuan Penerima
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  
                  placeholder="Contoh. John Doe"
                  hide-details
  
                  v-model="form.for"
                  :success="valid"
                  :error-messages="errors"
                  required
                  class="mb-3"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Tujuan Penerima {{ errors[0] }}
                      </v-tooltip>
                    </div>
  
                    <div v-if="form.for !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-card-text>
          </v-card>
  
          <ValidationProvider 
            name="Nama File" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Nama File
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Surat Menyurat"
              hide-details
  
              v-model="form.title"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Nama File {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.title !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <ValidationProvider 
            name="Nomor" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Nomor
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. 005/PT.UMB/IV/2022"
              hide-details
  
              v-model="form.template_meta_json_object.nomor"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px; width: 70%;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Nomor {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.nomor !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <ValidationProvider 
            name="Lampiran" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Lampiran
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. 1 Lembar"
              hide-details
  
              v-model="form.template_meta_json_object.lampiran"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px; width: 50%;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Lampiran {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.lampiran !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <ValidationProvider 
            name="Hal" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Hal
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Undangan Pengajian dan Buka Bersama Keluarga Besar PT. UMB"
              hide-details
  
              v-model="form.template_meta_json_object.hal"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px; width: 70%;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Hal {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.hal !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <div>
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Tanggal
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
  
            <v-menu
              ref="tanggal"
              min-width="290px"
              max-width="290px"
              transition="scale-transition"
              offset-y
              :nudge-right="40"
              :close-on-content-click="false"
              v-model="picker.tanggal">
              <template v-slot:activator="{ on, attrs }">
                <ValidationProvider 
                  name="Tanggal" 
                  rules="required"
                  v-slot="{ errors, valid }">
                  <v-text-field
                    readonly
                    filled
                    rounded
                    dense
                    :color="set_color"
                    placeholder="Pilih Tanggal"
                    hide-details
                    clearable
  
                    @click:clear="form.template_meta_json_object.tanggal = null;"
                    v-on="on"
                    v-bind="attrs"
  
                    v-model="form.template_meta_json_object.tanggal"
                    :success="form.template_meta_json_object.tanggal !== null && valid"
                    :error-messages="errors"
                    class="mb-6"
                    style="border-radius: 10px; width: 40%;">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          Tanggal {{ errors[0] }}
                        </v-tooltip>
                      </div>
  
                      <div v-if="form.template_meta_json_object.tanggal !== null && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </template>
  
              <v-date-picker 
                :color="set_color"
                v-model="form.template_meta_json_object.tanggal"
                @input="picker.tanggal = false">
              </v-date-picker>
            </v-menu>
          </div>
  
          <ValidationProvider 
          name="Nama Penerima" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Nama Penerima
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Nama Penerima."
            hide-details

            v-model="form.template_meta_json_object.nama_penerima"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Nama Penerima {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.nama_penerima !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>


  
        <ValidationProvider 
          name="Kegiatan" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Kegiatan
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Kegiatan"
            hide-details

            v-model="form.template_meta_json_object.kegiatan"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Kegiatan {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.kegiatan !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider
          name="Unit" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Unit
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>

          <v-autocomplete
            filled
            rounded
            dense
            :color="set_color"
            hide-details
            placeholder="Contoh. UMB Boga"

            :loading="process.unit"
            
            :items="units"
            item-value="name"
            item-text="name"
            :item-color="set_color"

            v-model="form.template_meta_json_object.unit"
            :success="form.template_meta_json_object.unit !== '' && valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Unit {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.unit !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-autocomplete>
        </ValidationProvider>



        <ValidationProvider 
          name="Permohonan bentuk sponsorship" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Permohonan bentuk sponsorship
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. doorprize"
            hide-details

            v-model="form.template_meta_json_object.permohonan"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Permohonan bentuk sponsorship {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.permohonan !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>
  
          <v-row>
            <v-col
              cols="12"
              md="5"
              class="py-0">
              <div>
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Hari/Tanggal
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
  
                <v-menu
                  ref="hari_tanggal"
                  min-width="290px"
                  max-width="290px"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  :close-on-content-click="false"
                  v-model="picker.tanggal_mulai">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      name="Hari/Tanggal" 
                      rules="required"
                      v-slot="{ errors, valid }">
                      <v-text-field
                        readonly
                        filled
                        rounded
                        dense
                        :color="set_color"
                        placeholder="Pilih Tanggal"
                        hide-details
                        clearable
  
                        @click:clear="form.template_meta_json_object.hari_tanggal = null;"
                        v-on="on"
                        v-bind="attrs"
  
                        v-model="form.template_meta_json_object.hari_tanggal"
                        :success="form.template_meta_json_object.hari_tanggal !== null && valid"
                        :error-messages="errors"
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Hari/Tanggal {{ errors[0] }}
                            </v-tooltip>
                          </div>
  
                          <div v-if="form.template_meta_json_object.hari_tanggal !== null && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </template>
  
                  <v-date-picker 
                    :color="set_color"
                    v-model="form.template_meta_json_object.hari_tanggal"
                    @input="picker.tanggal_mulai = false">
                  </v-date-picker>
                </v-menu>
              </div>
            </v-col>
  
            <v-col
              cols="12"
              md="5"
              class="py-0">
              <div>
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Pukul
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
  
                <v-menu
                  ref="pukul"
                  v-model="time.pukul"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="form.template_meta_json_object.pukul"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      name="Pukul" 
                      rules="required"
                      v-slot="{ errors, valid }">
                      <v-text-field
                        readonly
                        
                        filled
                        rounded
                        dense
                        :color="set_color"
                        placeholder="Contoh. 09:00"
                        hide-details
  
                        clearable
                        @click:clear="form.template_meta_json_object.pukul = null"
                        v-on="on"
                        v-bind="attrs"
  
                        v-model="form.template_meta_json_object.pukul"
                        :success="valid"
                        :error-messages="errors"
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Pukul {{ errors[0] }}
                            </v-tooltip>
                          </div>
  
                          <div v-if="form.template_meta_json_object.pukul !== null && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </template>
  
                  <v-time-picker
                    v-if="time.pukul"
                    v-model="form.template_meta_json_object.pukul"
                    full-width
                    :color="set_color"
                    format="24hr"
                    @click:minute="$refs.pukul.save(`${form.template_meta_json_object.pukul}`);">
                  </v-time-picker>
                </v-menu>
              </div>
            </v-col>
          </v-row>
  
          <ValidationProvider 
            name="Tempat" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Tempat
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Gedung Sportorium UMY, Lantai Dasar"
              hide-details
  
              v-model="form.template_meta_json_object.tempat"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Tempat {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.tempat !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <ValidationProvider 
            name="Nama Yang Bertandatangan" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Nama Yang Bertandatangan
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Dr. Alni Rahmawati, SE., MM."
              hide-details
  
              v-model="form.template_meta_json_object.nama_1"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Nama Yang Bertandatangan {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.nama_1 !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <ValidationProvider 
            name="Jabatan Yang Bertandatangan" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Jabatan Yang Bertandatangan
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Direktur Utama PT.UMB."
              hide-details
  
              v-model="form.template_meta_json_object.jabatan_1"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-3"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Jabatan Yang Bertandatangan {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.jabatan_1 !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
        </v-col>
  
        <v-col
          cols="12"
          md="6">
          <v-card
            flat
            style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
            <div
              ref="arsippdf"
              style="padding: 50px;">
              <v-card-text
                class="black--text py-2">
                <v-row>
                  <v-col
                    cols="12"
                    md="7">
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        Nomor
                      </v-col>
  
                      <v-col
                        cols="12"
                        md="8"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        : {{ form.template_meta_json_object.nomor !== '' ? form.template_meta_json_object.nomor : '__________' }}
                      </v-col>
                    </v-row>
  
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        Lampiran
                      </v-col>
  
                      <v-col
                        cols="12"
                        md="8"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        : {{ form.template_meta_json_object.lampiran !== '' ? form.template_meta_json_object.lampiran : '__________' }}
                      </v-col>
                    </v-row>
  
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        Hal
                      </v-col>
  
                      <v-col
                        cols="12"
                        md="8"
                        class="py-0 d-flex align-start"
                        style="padding-top: 0px !important; padding-bottom: 0px !important; display: flex !important; align-items: flex-start !important;">
                        : <span class="ml-1" style="font-weight: 500; margin-left: 4px !important;">{{ form.template_meta_json_object.hal !== '' ? form.template_meta_json_object.hal : '__________' }}</span>
                      </v-col>
                    </v-row>
                  </v-col>
  
                  <!-- <v-col
                    cols="12"
                    md="5">
                    <div
                      class="text-right"
                      style="text-align: right !important;">
                      Yogyakarta, {{ form.template_meta_json_object.tanggal | fulldate }}
                    </div>
                  </v-col> -->
                </v-row>
  
                <div
                  class="mt-6"
                  style="margin-top: 24px !important;">
                  <div
                    style="margin-bottom: 1px;">
                    Kepada Yth.
                  </div>
  
                  <div
                    style="margin-bottom: 1px;">
                    {{ form.template_meta_json_object.nama_penerima !== '' ? form.template_meta_json_object.nama_penerima : '__________' }}
                  </div>
  
                  <div
                    style="margin-bottom: 1px;">
                    di Tempat
                  </div>
                </div>
  
                <div
                  class="mt-10"
                  style="margin-top: 40px !important;">
                  <v-img
                    contain
                    width="175"
                    height="auto"
                    alt="umb" 
                    :src="require('@/assets/image/assalam.jpeg')">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
  
                  <div
                    class="my-4"
                    style="margin-top: 16px !important; margin-bottom: 16px !important;">
                    <div
                      class="mb-4"
                      style="margin-bottom: 16px !important;">
                      Puji syukur kami panjatkan kehadirat Allah SWT yang senantiasa melimpahkan Rahmat, hidayah serta inayahNya kepada kita semua. Sholawat dan salam semoga tetap tercurah kepada junjungan kita Nabi Muhammad SAW. Aamiin. 
                    </div>

                    <div
                      class="mb-4"
                      style="margin-bottom: 16px !important;">
                      Sehubungan dengan adanya kegiatan {{ form.template_meta_json_object.kegiatan !== '' ? form.template_meta_json_object.kegiatan : '__________' }}, maka {{ form.template_meta_json_object.unit !== '' ? form.template_meta_json_object.unit : '__________' }} bermaksud mengajukan permohonan sponsorship berupa {{ form.template_meta_json_object.permohonan !== '' ? form.template_meta_json_object.permohonan : '__________' }} untuk menunjang kelacaran kegiatan tersebut. 
                    </div>
  
                    <div
                      class="mb-4"
                      style="margin-bottom: 16px !important;">
                      Perlu kami sampaikan, bahwa kegiatan sebagaimana dimaksud insyaAllah diselenggarakan pada :
                    </div>
  
                    <div
                      class="mb-4"
                      style="margin-bottom: 16px !important;">
                      <v-row>
                        <v-col
                          cols="12"
                          md="3"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Hari/Tanggal
                        </v-col>
  
                        <v-col
                          cols="12"
                          md="9"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : 
                          <span v-if="form.template_meta_json_object.hari_tanggal !== '' && form.template_meta_json_object.hari_tanggal !== null">
                            {{ form.template_meta_json_object.hari_tanggal | weekday }}
                          </span>
  
                          <span v-else>
                            __________
                          </span>
                          
                          ,
  
                          <span v-if="form.template_meta_json_object.hari_tanggal !== '' && form.template_meta_json_object.hari_tanggal !== null">
                            {{ form.template_meta_json_object.hari_tanggal | fulldate }}
                          </span>
  
                          <span v-else>
                            __________
                          </span>
                        </v-col>
                      </v-row>
  
                      <v-row>
                        <v-col
                          cols="12"
                          md="3"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Pukul
                        </v-col>
  
                        <v-col
                          cols="12"
                          md="9"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : {{ form.template_meta_json_object.pukul !== '' ? form.template_meta_json_object.pukul : '__________' }}
                        </v-col>
                      </v-row>
  
                      <v-row>
                        <v-col
                          cols="12"
                          md="3"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Tempat
                        </v-col>
  
                        <v-col
                          cols="12"
                          md="9"
                          class="py-0 d-flex align-start"
                          style="padding-top: 0px !important; padding-bottom: 0px !important; display: flex !important; lign-items: flex-start !important;">
                          : 
                          <span
                            class="ml-1"
                            style="margin-left: 4px !important;">
                            {{ form.template_meta_json_object.tempat !== '' ? form.template_meta_json_object.tempat : '__________' }}
                          </span>
                        </v-col>
                      </v-row>
                    </div>
  
                    <div
                      style="">
                      Demikian surat permohonan ini kami sampaikan, terimakasih atas perhatian dan kerjasamanya.
                    </div>
                  </div>
  
                  <v-img
                    contain
                    width="175"
                    height="auto"
                    alt="umb" 
                    :src="require('@/assets/image/wassalam.jpeg')">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </div>
  
                <v-row
                  justify="end"
                  class="mt-8"
                  style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 32px !important;">
                  <v-col
                    cols="12"
                    md="6"
                    class="text-center"
                    style="text-align: right !important;">
                    <div>
                      Yogyakarta, {{ form.template_meta_json_object.tanggal | fulldate }}
                    </div>

                    <div
                      class="mb-16"
                      style="margin-bottom: 64px !important;">
                      {{ form.template_meta_json_object.jabatan_1 !== '' ? form.template_meta_json_object.jabatan_1 : '__________' }}
                    </div>

                    <div>
                      {{ form.template_meta_json_object.nama_1 !== '' ? form.template_meta_json_object.nama_1 : '__________' }}
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </template>
  
  <script>
    import { get, post, put, destroy } from "@/service/Axios";
    import { TokenService } from "@/service/Storage.Service";
    import axios from "axios";
    import moment from "moment"
    import "moment/locale/id"
    import html2pdf from 'html2pdf.js'
    export default {
      props: {
        form: {
          type: Object,
          default: {}
        },
        units: {
          type: Array,
          default: []
        },
        process: {
          type: Object,
          default: {}
        }
      },
      data () {
        return {
          picker: {
            expired: false,
            tanggal: false,
            tanggal_mulai: false,
            tanggal_selesai: false,
            tanggal_masuk: false,
  
            range: false
          },
  
          time: {
            pukul: false
          },
        }
      },
      components: {
        
      },
      watch: {
  
      },
      computed: {
        user () {
          return this.$store.state.user
        },
        
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb_soft () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.2)`
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.2)`
        },
  
        configHeaders () {
          return this.headers.filter(header => !header.hide)  
        },
  
        // formattedDate: {
        //   get () {
        //     return (this.form.template_meta_json_object.tanggal && this.form.template_meta_json_object.tanggal.length === 10) ? moment(this.form.template_meta_json_object.tanggal).format('DD MMMM YYYY') : this.form.template_meta_json_object.tanggal
        //   },
        //   set (newValue) {
        //     if (newValue && newValue.length == 10) {
        //         let newDate = `${newValue.substring(6, 10)}-${newValue.substring(3, 5)}-${newValue.substring(0, 2)}`
        //         this.form.template_meta_json_object.tanggal = newDate
        //     }
        //   }
        // },
  
        date_range () {
          return this.filter.dates.join(' s/d ')
        }
      },
      mounted () {
        
      },
      methods: {
        add_pegawai () {
          this.form.template_meta_json_object.kepada.push({
            nama: '',
            unit: ''
          })
        },
      }
    }
  </script>
  